import { ILocation } from './location.model';

export enum UserRole {
  Admin = 'ROLE_ADMIN',
  Mod = 'ROLE_MODERATOR',
  User = 'ROLE_USER',
  Super = 'ROLE_SUPER_MODERATOR',
  Alumni = 'ROLE_ALUMNI',
  Guest = 'ROLE_GUEST',
}

export enum UserRoleId {
  Admin = 1,
  Mod = 2,
  User = 3,
  Super = 4,
  Alumni = 5,
  Guest = 6,
}

export type IRoleEntity = {
  id: number;
  name: string;
  code: UserRole;
};

export type BaseUser = {
  id: number;
  login: string;
  bannerClosed: boolean;
  firstName?: string;
  lastName?: string;
  lastVisitedLocationId?: number;
  assignedLocations?: ILocation[];
};

export type IUser = BaseUser & {
  role?: IRoleEntity;
  lastVisitedLocation?: ILocation;
  uniqueUser?: boolean;
  topPerformer?: boolean;
  topPerformerStartDate?: string;
  topPerformerEndDate?: string;
};

export type IResponseAuth = {
  refresh_token: string;
  access_token: string;
  user: IUser;
};

export type ICache = {
  data: null | IResponseAuth;
  time: null | number;
};

export type AuthUserDTO = {
  login: string;
  password: string;
};

export interface IAssignedHr {
  id: number;
  login: string;
  firstName: string | null;
  lastName: string | null;
  role: {
    id: number;
    name: string;
    code: string;
  };
  lastVisitedLocation: ILocation;
  assignedLocations: ILocation[];
}

export interface IAssignedHrResponse {
  code: number;
  content: IAssignedHr[];
}
